import { UntypedFormControl } from '@angular/forms';

export function mustMatch(controlName: string) {
  const input1ControlName = controlName;
  return function(input2: UntypedFormControl) {
    if (input2.root.get(input1ControlName) === null) {
      return null;
    }

    const input1Value = input2.root.get(input1ControlName).value;
    if (input1Value !== input2.value) {
      return { mustMatch: true};
    }
    // Validation passes
    return null;
  };
}
